import type { inicio as pt } from '../pt-BR/inicio';
import type { Traducao } from '../Traducao';

export const inicio = {
  saudacao: 'Hello, {{nome}}',
  responder: 'Answer',
  perfis: {
    profissional: 'Professional',
    administrador: 'Administrator',
  },
} as const satisfies Traducao<typeof pt>;
